import { DirectiveBinding } from 'vue'

function handleClick(event: Event): void {
  const target = event.target as HTMLElement
  const currentTarget = event.currentTarget as HTMLElement

  // If this is a mention link or any other special link type, let their handlers work
  const linkInPath = event.composedPath().find((el): el is HTMLElement => {
    const element = el as HTMLElement
    return element.tagName === 'A' && element.hasAttribute('data-type')
  })

  if (linkInPath) {
    console.log('Found special link, preventing event bubbling')
    return
  }

  // If this is a regular link within the content, let it proceed
  if (target.tagName === 'A' && !target.hasAttribute('data-prevent-nav')) {
    console.log('Found regular link, allowing click to proceed')
    event.stopPropagation()
    return
  }

  // If this is the wrapper anchor, prevent its default behavior
  if (currentTarget.hasAttribute('data-prevent-nav')) {
    console.log('Preventing default on wrapper anchor')
    event.preventDefault()
  }
}

export const vPreventDefault = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    // If value is provided and false, don't prevent default
    if (binding.value === false) return

    // Mark this element as a wrapper anchor
    el.setAttribute('data-prevent-nav', '')

    // Use capture phase to ensure we handle this before other handlers
    el.addEventListener('click', handleClick, true)
  },
  unmounted(el: HTMLElement) {
    el.removeEventListener('click', handleClick, true)
    el.removeAttribute('data-prevent-nav')
  },
}
